import { render } from "./EditorWrapper.vue?vue&type=template&id=dde949ac&scoped=true"
import script from "./EditorWrapper.vue?vue&type=script&lang=js"
export * from "./EditorWrapper.vue?vue&type=script&lang=js"

import "./EditorWrapper.vue?vue&type=style&index=0&id=dde949ac&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dde949ac"]])

export default __exports__